import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import phorestLogo from 'my-phorest/assets/images/phorest-logo.svg';
import screenshotPng from 'my-phorest/assets/images/phorest10-desktop@2x.png';
import screenshotWebP from 'my-phorest/assets/images/phorest10-desktop@2x.webp';

export default class DesktopController extends Controller {
  @tracked currentVersion = '';

  phorestLogoSrc = phorestLogo;
  screenshotPngSrc = screenshotPng;
  screenshotWebPSrc = screenshotWebP;

  @action
  setVersion(manifest) {
    this.currentVersion = manifest.version;
  }
}
